import Endpoints from '../../constants/Endpoints';
import axios from '../axiosInstance';
import { IVerifyAccessToken } from '../types';

// const endpointAuth = { ...EPtAuth.auth };

const verifyAccessToken = async (authToken: string, config = {}) => {
  const params = { accessToken: authToken };

  const res = await axios.post<never, IVerifyAccessToken>(
    '/api/auth/verify-access-token',
    params,
    config
  );
  return res;
};

const refreshAccessToken = async (refreshToken: string, config = {}) => {
  return await axios.post<never, IVerifyAccessToken>('/api/auth/refresh-token', { refreshToken }, {
    ...config,
    ignoreToken: true,
  } as any);
};

const appLogin = async (params: { accessToken: string | null }, config = {}) => {
  const res = await axios.post<never, any>(Endpoints.Auth.AppRedirectLogin, params, config);

  return res;
};

const apis = {
  verifyAccessToken,
  refreshAccessToken,
  appLogin,
};

export default apis;
